module.exports = __webpack_public_path__ + "img/JobInterview.265a9096.svg";